<div [ngClass]="{ errorLine: errorState === true }">
  <re-captcha
    #recaptchaComponent
    [id]="id"
    [size]="to.size"
    [theme]="to.theme"
    [badge]="to.badge"
    [tabIndex]="to.tabindex"
    [formControl]="formControl"
  >
  </re-captcha>
</div>
